import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/guide/page";
import SpreadsheetWorkflow from "../pages/workflow/page";
import SpreadsheetComparison from "../pages/comparison/page";
import SetupGuide from "../pages/setup/page";
import CategoriesGuide from "../pages/categories-guide/page";
import PricingGuide from "../pages/pricing/page";
import TrackingGuide from "../pages/tracking/page";
import SourcingGuide from "../pages/sourcing/page";
import TemplatesGuide from "../pages/templates/page";
import AutomationGuide from "../pages/automation/page";
import BestPractices from "../pages/best-practices/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-workflow",
    element: <SpreadsheetWorkflow />,
  },
  {
    path: "/mulebuy-spreadsheet-comparison",
    element: <SpreadsheetComparison />,
  },
  {
    path: "/mulebuy-spreadsheet-setup",
    element: <SetupGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-categories",
    element: <CategoriesGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-pricing",
    element: <PricingGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-tracking",
    element: <TrackingGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-sourcing",
    element: <SourcingGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-templates",
    element: <TemplatesGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-automation",
    element: <AutomationGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-best-practices",
    element: <BestPractices />,
  },
  {
    path: "/mulebuy-spreadsheet-faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;